import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { Response } from "../interfaces/services/Response";

export const getMeusAtestados = async (): Promise<Response | null> => {
    try {
        
        const response = await apiClientes.get('/Beneficiario/GetMeusAtestados', {
            params: {
                latitude: 0,
                longitude: 0,
                start: 0,
                limit: 50,
            },
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getAtestado = async (idAtestado: string): Promise<Response | null> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await apiClientes.get(`/Beneficiario/GetAtestado?idAtestado=${idAtestado}`, { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
        resolve(response);
      } catch (error: any) {
        reject(error.response);
      }
    })
    
  };